import axios from "axios";
import { useAxiosHook } from "./useAxiosHook";
import { isFunction } from "lodash";
import { useDispatch } from "react-redux";

import { sortObjectWithArrays } from "../_src_shared/utils/functions/sortObjectWithArraysCaseSensitive";
import { fetchedSelectionsSetFileDocGroupAndTypes } from "../redux/reducers/fetchedSelectionsReducer";

const ROUTE_PREFIX_UNDERWRITING = "underwriting";

export const useFetchedSelectionsRequestsHook = () => {
  const {
    axiosPostIsLoading,
    isLoading,
    axiosGetIsLoading,
    axiosError,
    axiosGetRequest,
  } = useAxiosHook();

  const loading = isLoading || axiosGetIsLoading || axiosPostIsLoading;
  const error = axiosError;
  const dispatch = useDispatch();

  const getLoanFileDocGroupsAndTypes = async ({ onSuccessFn, onFailFn }) => {
    const endpoint = `${ROUTE_PREFIX_UNDERWRITING}/file_doc_types`;
    const source = axios.CancelToken.source();
    const params = {
      name: "Get Loan File Doc Groups And Types",
      path: endpoint,

      cancelSource: source,
      onSuccessFn: (d) => {
        const alphabetizedData = sortObjectWithArrays(d);

        if (isFunction(onSuccessFn)) {
          onSuccessFn(alphabetizedData);
        }
        dispatch(fetchedSelectionsSetFileDocGroupAndTypes(alphabetizedData));
      },
      onFailFn,
    };
    await axiosGetRequest(params);
  };

  return {
    error,
    loading,

    getLoanFileDocGroupsAndTypes,
  };
};
